import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import onClickOutside from 'react-onclickoutside';
import BuddyLogo from '../../assets/images/buddy_128x128.png';
import './SuccessModal.scss';

const SuccessModal = ({ setModal, result }) => (
  <div className="successModal">
    <h2 className="successTitle">
      <FormattedMessage
        id="successTitle"
        defaultMessage="Success! {device} is registered."
        values={{ device: result.description }}
      />
    </h2>
    <img src={BuddyLogo} className="successLogo" alt="" />
    <div className="successText">
      <FormattedMessage
        id="successText"
        defaultMessage="You can modify the settings below, or click Continue to get started with the device."
      />
    </div>
    <div className="successButtonBar">
      <button
        className="mainButton"
        onClick={() => {
          window.open(`/go_setup?serial=${result.serial}`);
          setModal(null);
        }}
      >
        <FormattedMessage
          id="modifyButton"
          defaultMessage="Modify Settings"
        />
      </button>
      <button
        className="mainButton secondaryButton"
        onClick={() => {
          setModal(null);
        }}
      >
        <FormattedMessage
          id="continueButton"
          defaultMessage="Continue"
        />
      </button>
    </div>
  </div>
);

SuccessModal.propTypes = {
  result: PT.object,
  intl: PT.object,
  setModal: PT.func
};

export default onClickOutside(SuccessModal);



// WEBPACK FOOTER //
// ./src/components/SuccessModal/SuccessModal.js